module.exports = __webpack_public_path__ + "fonts/FontAwesome.0d2717cd.otf";